import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  loading: boolean;
  error: string | null;
  success: string | null;
  selectedBranch: number | null;
  theme: 'light' | 'dark';
  notification: {
    open: boolean;
    message: string | null;
    type: 'success' | 'error' | 'warning' | 'info' | null;
  };
}

const initialState: UIState = {
  sidebarOpen: true,
  loading: false,
  error: null,
  success: null,
  selectedBranch: null,
  theme: 'light',
  notification: {
    open: false,
    message: null,
    type: null,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload;
    },
    setSelectedBranch: (state, action: PayloadAction<number | null>) => {
      state.selectedBranch = action.payload;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    showNotification: (state, action: PayloadAction<{
      type: 'success' | 'error' | 'warning' | 'info';
      message: string;
    }>) => {
      state.notification = {
        open: true,
        message: action.payload.message,
        type: action.payload.type,
      };
    },
    hideNotification: (state) => {
      state.notification = {
        open: false,
        message: null,
        type: null,
      };
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setLoading,
  setError,
  setSuccess,
  setSelectedBranch,
  setTheme,
  showNotification,
  hideNotification,
} = uiSlice.actions;

export default uiSlice.reducer;
